import {all} from 'redux-saga/effects';
import {saga as pollSaga} from './poll';

export default function* rootSaga() {
  yield all([
    pollSaga(),
  ]);
}
